export enum SharingIssueLevel {
    None,
    Warning,
    Error,
}
